<template>
  <v-container fluid>
    <v-card width="100%" tile elevation="6" height="200px">
      <div id="contenedor">
        <v-layout row wrap="">
          <v-flex xs12 sm12 md12>
            <v-toolbar flat elevation="15" class="mt-9" height="80">
              <v-card class="icon" height="110" width="105">
                <v-icon style="margin-left: 33px; margin-top: 29px" color="white" x-large="">mdi-fingerprint</v-icon>
              </v-card>
              <div class="usuario">DESENROLAMIENTO DE HUELLAS</div> 
              <v-spacer></v-spacer>
              <v-dialog v-model="dialog" max-width="700px" persistent>
                <template v-slot:activator="{ on }">
                  <v-btn dark class="botonplus" v-on="on">
                    <v-icon color="white">mdi-plus-thick</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-card-title class="nav">
                    <span class="headline" style="color: white">
                      <v-icon color="white">mdi-cloud-upload</v-icon>
                      Subir caso
                    </span>
                  </v-card-title>
                  <v-card-text>
                    <v-container grid-list-md>
                      <v-layout wrap>
                        <!-- Preguntas -->
                        <!-- 🆕 Selector de Reglamento/Requerimiento (Solo visible para Apostar) -->
                        <v-flex xs12 sm12 md12 v-if="idEmpresa == 2">
                          <v-autocomplete
                            v-model="requerimientoSeleccionado"
                            :items="requerimientosApostar"
                            item-text="cc_nombre_requerimiento"
                            item-value="cc_id_requerimientos"
                            label="Seleccione el Reglamento / Requerimiento"
                            outlined
                            dense
                            required
                            @change="obtenerPreguntas"
                          >
                            <template v-slot:item="{ item }">
                              <v-list-item-content>
                                <v-list-item-title>{{ item.cc_nombre_requerimiento }}</v-list-item-title>
                                <v-list-item-subtitle>ID: {{ item.cc_id_requerimientos }} - Área: {{ item.cc_nombre_area }}</v-list-item-subtitle>
                              </v-list-item-content>
                            </template>
                          </v-autocomplete>
                        </v-flex>

                        <!-- FORMA ORIGINAL: Solo para Facilisimo (idEmpresa != 2) -->
                        <template v-if="idEmpresa != 2">
                            <!-- Selector de Punto de Venta -->
                            <v-flex xs12 sm12 md12>
                              <v-autocomplete
                                v-model="puntoSeleccionado"
                                :items="puntos"
                                item-text="nombre"
                                item-value="idPunto"
                                label="Seleccione el punto de venta"
                                outlined
                                dense
                                required
                                :loading="cargandoPuntos"
                                no-data-text="No hay puntos disponibles"
                              >
                                <template v-slot:item="{ item }">
                                  <v-list-item-content>
                                    <v-list-item-title>{{ item.nombre }}</v-list-item-title>
                                    <v-list-item-subtitle v-if="item.nombreEmpresa">
                                      <strong>Empresa:</strong> {{ item.nombreEmpresa }}
                                    </v-list-item-subtitle>
                                  </v-list-item-content>
                                </template>
                                <template v-slot:selection="{ item }">
                                  <span>{{ item.nombre }} <strong v-if="item.nombreEmpresa">({{ item.nombreEmpresa }})</strong></span>
                                </template>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                            <v-subheader>¿Realizó proceso en SETA?</v-subheader>
                            <v-btn-toggle v-model="procesoSeta" mandatory>
                                <v-btn :value="'Sí'" @click="procesoSeta = 'Sí'">Sí</v-btn>
                                <v-btn :value="'No'" @click="procesoSeta = 'No'">No</v-btn>
                            </v-btn-toggle>
                            </v-flex>
                            <v-flex xs12 sm6 md6>
                            <v-subheader>El desenrolamiento es para:</v-subheader>
                            <v-checkbox v-model="editedItem.envioGiros" label="Envío de giros" dense></v-checkbox>
                            <v-checkbox v-model="editedItem.pagoGiros" label="Pago de giros" dense></v-checkbox>
                            </v-flex>
                            <!-- Fin preguntas -->
                            <v-flex xs12 sm12 md12>
                            <v-text-field v-model="editedItem.cedula" label="Escriba el nombre del usuario a desenrolar y número de cédula"></v-text-field>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                            <v-text-field v-model="editedItem.telefono" label="Escriba el número de teléfono del asesor"></v-text-field>
                          </v-flex>
                          <v-flex xs12 sm12 md12>
                            <v-text-field v-model="editedItem.motivo" label="Escriba el motivo de la solicitud"></v-text-field>
                            <span style="font-weight: bold; font-size: 16px;">Envíe fotografía al número 3148902114 donde se muestre pantalla de SETA, Carné de asesora y cédula del cliente (Solo el frente)</span>
                            </v-flex>
                        </template>

                        <!-- NUEVA FORMA DINÁMICA: Solo para Apostar (idEmpresa == 2) -->
                        <template v-else>
                            <v-flex xs12 sm12 md12 v-if="cargandoPreguntas" class="text-center">
                                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                                <p>Cargando preguntas...</p>
                            </v-flex>
                            
                            <template v-if="!cargandoPreguntas && preguntasDinamicas.length > 0">
                                <!-- CAMBIO: xs12 sm6 md6 para inputs, pero sm12 md12 para texto informativo (null) -->
                                <v-flex 
                                    xs12 
                                    :sm6="!!pregunta.tipo_respuesta && !(pregunta.pregunta && pregunta.pregunta.toUpperCase().includes('MOTIVO'))" 
                                    :md6="!!pregunta.tipo_respuesta && !(pregunta.pregunta && pregunta.pregunta.toUpperCase().includes('MOTIVO'))" 
                                    :sm12="!pregunta.tipo_respuesta || (pregunta.pregunta && pregunta.pregunta.toUpperCase().includes('MOTIVO'))" 
                                    :md12="!pregunta.tipo_respuesta || (pregunta.pregunta && pregunta.pregunta.toUpperCase().includes('MOTIVO'))" 
                                    v-for="pregunta in preguntasDinamicas" 
                                    :key="pregunta.id_pregunta"
                                >
                                    <!-- Tipo 1: Texto Libre -->
                                    <v-text-field 
                                        v-if="pregunta.tipo_respuesta == 1"
                                        v-model="respuestasDinamicas[pregunta.id_pregunta]"
                                        :label="pregunta.pregunta"
                                        :required="pregunta.es_obligatoria == 1"
                                        :rules="pregunta.es_obligatoria == 1 ? [v => !!v || 'Campo requerido'] : []"
                                        outlined dense
                                    ></v-text-field>

                                    <!-- Tipo 2: Solo Números -->
                                    <v-text-field 
                                        v-if="pregunta.tipo_respuesta == 2"
                                        v-model="respuestasDinamicas[pregunta.id_pregunta]"
                                        :label="pregunta.pregunta"
                                        type="number"
                                        :required="pregunta.es_obligatoria == 1"
                                        :rules="pregunta.es_obligatoria == 1 ? [v => !!v || 'Campo requerido'] : []"
                                        outlined dense
                                    ></v-text-field>

                                    <!-- Tipo 3: Cédula -->
                                    <v-text-field 
                                        v-if="pregunta.tipo_respuesta == 3"
                                        v-model="respuestasDinamicas[pregunta.id_pregunta]"
                                        :label="pregunta.pregunta"
                                        type="number"
                                        counter="10"
                                        :required="pregunta.es_obligatoria == 1"
                                        :rules="pregunta.es_obligatoria == 1 ? [v => !!v || 'Campo requerido'] : []"
                                        outlined dense
                                    ></v-text-field>

                                    <!-- Tipo 4: Teléfono -->
                                    <v-text-field 
                                        v-if="pregunta.tipo_respuesta == 4"
                                        v-model="respuestasDinamicas[pregunta.id_pregunta]"
                                        :label="pregunta.pregunta"
                                        type="tel"
                                        counter="10"
                                        :required="pregunta.es_obligatoria == 1"
                                        :rules="pregunta.es_obligatoria == 1 ? [v => !!v || 'Campo requerido'] : []"
                                        outlined dense
                                    ></v-text-field>

                                    <!-- Tipo 6: Sí/No -->
                                    <div v-if="pregunta.tipo_respuesta == 6">
                                        <v-subheader>{{ pregunta.pregunta }}</v-subheader>
                                        <v-btn-toggle v-model="respuestasDinamicas[pregunta.id_pregunta]" mandatory>
                                            <v-btn value="Sí">Sí</v-btn>
                                            <v-btn value="No">No</v-btn>
                                        </v-btn-toggle>
                                    </div>
                                    
                                    <!-- Tipo Mensaje/Solo Texto (Si existe) -->
                                    <div v-if="!pregunta.tipo_respuesta && pregunta.pregunta" style="padding: 10px;">
                                        <span style="font-weight: bold">{{ pregunta.pregunta }}</span>
                                    </div>
                                </v-flex>
                                <v-flex xs12 sm12 md12 v-if="!esColombiaMayor">
                                    <span style="font-weight: bold; font-size: 16px;">NOTA: Por favor enviar foto del documento de identidad por ambos lados al número 3103980919.</span>
                                </v-flex>
                            </template>
                            <template v-else-if="!cargandoPreguntas && preguntasDinamicas.length === 0">
                                <v-flex xs12 class="text-center">
                                    <v-alert type="info" text>
                                        Seleccione un requerimiento para ver el formulario.
                                    </v-alert>
                                </v-flex>
                            </template>
                        </template>

                      </v-layout>
                    </v-container>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="#f7e506" @click="close">Cancelar</v-btn>
                    <v-btn color="#f7e506" :disabled="!isFormularioValido" @click="save">Guardar</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-toolbar>
          </v-flex>
        </v-layout>
      </div>
    </v-card>
  </v-container>
</template>
  
<script>
  import axios from "axios";
  import env from "../../env";
  import swal from "sweetalert";
  export default {
    data() {
      return {
        dialog: false,
        search: "",
        usuarios: [],
        procesoSeta: '',
        envioGiros: false,
        pagoGiros: false,
        idEmpresa: localStorage.getItem("idEmpresa") || 1,
        requerimientosApostar: [],
        requerimientoSeleccionado: (localStorage.getItem("idEmpresa") == 2) ? 35 : 144, // 35 Apostar, 144 Facilísimo
        // Variables para puntos de venta (Facilísimo)
        puntos: [],
        puntoSeleccionado: null,
        cargandoPuntos: false,
        // Variables para preguntas dinámicas
        preguntasDinamicas: [],
        respuestasDinamicas: {},
        cargandoPreguntas: false,
        esColombiaMayor: false, // Flag para controlar visualización
        
        defaultItem: {
          procesoSeta: "",
          envioGiros: false,
          pagoGiros: false,
          cedula: "",
          telefono: "",
          motivo: "",
        },
        editedItem: {
          procesoSeta: "",
          envioGiros: false,
          pagoGiros: false,
          cedula: "",
          telefono: "",
          motivo: "",
        },
        editedIndex: -1,
      };
    },
    watch: {
      dialog(val) {
        val || this.close();
      },
    },
    computed: {
      isFormularioValido() {
        // Para Facilisimo (idEmpresa != 2) se exige llenar estos 5 campos
        if (this.idEmpresa != 2) {
          return !!this.puntoSeleccionado &&
                 !!this.procesoSeta && 
                 !!this.editedItem.cedula && this.editedItem.cedula.trim() !== '' &&
                 !!this.editedItem.telefono && this.editedItem.telefono.trim() !== '' &&
                 !!this.editedItem.motivo && this.editedItem.motivo.trim() !== '';
        }
        // Para Apostar, la validación se hace ad-hoc en el método save (SweetAlert)
        return true;
      }
    },
    mounted() {
      if (this.idEmpresa == 2) {
        this.obtenerRequerimientosApostar();
      } else {
        // Cargar puntos de venta para Facilísimo
        this.obtenerPuntos();
      }
    },
  
    methods: {
      //METODO PARA CERRAR CARD
      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
          this.respuestasDinamicas = {};
        }, 300);
      },

      // 🆕 Método para obtener preguntas dinámicas
      obtenerPreguntas() {
        if (!this.requerimientoSeleccionado) return;
        
        this.cargandoPreguntas = true;
        this.preguntasDinamicas = [];
        this.respuestasDinamicas = {};
        this.esColombiaMayor = false;

        const idReq = parseInt(this.requerimientoSeleccionado);
        
        // Obtener nombre del requerimiento para valida reglas de negocio
        const reqObj = this.requerimientosApostar.find(r => r.cc_id_requerimientos == idReq);
        const nombreReq = reqObj ? reqObj.cc_nombre_requerimiento.toUpperCase() : '';
        
        const isBetplay = idReq === 30 || nombreReq.includes('BETPLAY');
        const isNominas = nombreReq.includes('NOMINA'); // Asumimos coincidencias con NOMINA o NOMINAS IVA
        const isColombiaMayor = idReq === 269 || nombreReq.includes('MAYOR'); // ID 269 o que diga Mayor

        if (isColombiaMayor) this.esColombiaMayor = true;

        axios.get(`${env.endpoint}callcenter/preguntas_bot?idRequerimiento=${idReq}`)
            .then(response => {
                let preguntas = [];
                if (response.data && response.data.preguntas) {
                    preguntas = response.data.preguntas.sort((a, b) => a.orden - b.orden);
                } else if (Array.isArray(response.data)) {
                    preguntas = response.data;
                }

                // ---------------------------------------------------------
                // 🌪️ LÓGICA DE FILTRADO Y REGLAS DE NEGOCIO (Hardcoded)
                // ---------------------------------------------------------
                
                preguntas = preguntas.filter(p => {
                    const texto = p.pregunta ? p.pregunta.toUpperCase() : '';

                    // 1. PIN del cliente (MENOS PARA BETPLAY)
                    if (texto.includes('PIN') && isBetplay) return false;

                    // 2. Fecha de nacimiento (MENOS PARA BETPLAY)
                    if (texto.includes('NACIMIENTO') && isBetplay) return false;

                    // 3. Fecha de expedición (MENOS PARA BETPLAY)
                    if (texto.includes('EXPEDICIÓN') || texto.includes('EXPEDICION')) {
                        if (isBetplay) return false;
                    }

                    // 4. Número de celular del cliente (SOLO PARA NOMINAS IVA)
                    // Buscamos "celular del cliente" para no confundir con teléfono del asesor
                    if (texto.includes('CELULAR') && texto.includes('CLIENTE')) {
                        if (!isNominas) return false;
                    }

                    // 5. Cédula del asesor (SOLO PARA NOMINAS IVA Y BETPLAY)
                    if (texto.includes('CÉDULA') || texto.includes('CEDULA')) {
                         if (texto.includes('ASESOR')) {
                             // Si NO es Nominas Y NO es Betplay, se oculta
                             if (!isNominas && !isBetplay) return false;
                         }
                    }

                    // 6. Eliminar campo de Foto (Solicitud Usuario: "YA NO LO NECESITAMOS")
                    if (texto.includes('FOTO') && texto.includes('DOCUMENTO')) return false;

                    return true;
                });

                // ---------------------------------------------------------
                // 🎨 TRANSFORMACIONES ESPECÍFICAS
                // ---------------------------------------------------------

                // 🎯 LÓGICA CUSTOM: Colombia Mayor (269)
                if (isColombiaMayor) {
                    const textoTerceraImagen = "NOTA: Por favor enviar foto del documento de identidad por ambos lados al número 3103980919.";
                    
                    preguntas.forEach(p => {
                        // Buscar input "Nota..." (o instrucciones de foto)
                        if (p.pregunta && p.pregunta.toLowerCase().includes("por favor enviar foto")) {
                            p.pregunta = textoTerceraImagen;
                            p.tipo_respuesta = null; // Convertir a texto estático
                            p.es_obligatoria = 0;
                        }
                    });
                }
                
                // 🎯 LÓGICA CUSTOM: Betplay (30)
                if (isBetplay) {
                   // Agregar campo "Motivo del desenrolamiento" si no existe
                   const existe = preguntas.find(p => p.pregunta.toUpperCase().includes('MOTIVO'));
                   if (!existe) {
                       const nuevoCampo = {
                           id_pregunta: 'custom_motivo_30',
                           pregunta: 'Motivo del desenrolamiento',
                           tipo_respuesta: 1, // Texto libre
                           es_obligatoria: 1,
                           orden: 999 
                       };
                       preguntas.push(nuevoCampo);
                   }
                }

                this.preguntasDinamicas = preguntas;
            })
            .catch(error => {
                console.error("Error cargando preguntas:", error);
                swal("Error", "No se pudieron cargar las preguntas del formulario", "error");
            })
            .finally(() => {
                this.cargandoPreguntas = false;
            });
      },

      //METODO PARA ESCALAR CASO
      save() {
        // Obtener el id_asesor desde el local storage
        const id = localStorage.getItem('id');
        const idEmpresa = localStorage.getItem('idEmpresa');
        let nuevoUsuario = new FormData();

        // LÓGICA DIFERENCIADA
        if (idEmpresa == 2) {
             // --- LÓGICA APOSTAR (Dinámica) ---
             
             // 1. Validar campos obligatorios
             // 1. Validar campos obligatorios
             const faltantes = this.preguntasDinamicas.filter(p => 
                 p.es_obligatoria == 1 && 
                 p.tipo_respuesta != null && // Solo validar si espera respuesta (no texto plano)
                 (!this.respuestasDinamicas[p.id_pregunta] || this.respuestasDinamicas[p.id_pregunta].toString().trim() === '')
             );

             if (faltantes.length > 0) {
                 const nombresFaltantes = faltantes.map(f => f.pregunta).join(', ');
                 swal("Atención", "Por favor diligencie los siguientes campos: " + nombresFaltantes, "warning");
                 return;
             }

             // 2. Mapear respuestas a campos del backend
             let cedulaEncontrada = "";
             let telefonoEncontrado = "";
             let descripcion = "RESPUESTAS FORMULARIO:\n";

             this.preguntasDinamicas.forEach(p => {
                 const respuesta = this.respuestasDinamicas[p.id_pregunta];
                 
                 // Construir descripción legible
                 if (respuesta) {
                    descripcion += `- ${p.pregunta}: ${respuesta}\n`;
                 }

                 // Mapeo inteligente
                 if (p.tipo_respuesta == 3) cedulaEncontrada = respuesta; // Tipo Cédula
                 if (p.tipo_respuesta == 4) telefonoEncontrado = respuesta; // Tipo Teléfono
             });

             nuevoUsuario.append("cc_id_asesor", id);
             nuevoUsuario.append("idEmpresa", idEmpresa);
             // Usar valores encontrados o vacíos
             nuevoUsuario.append("cedula", cedulaEncontrada || "0"); 
             nuevoUsuario.append("telefono", telefonoEncontrado || "0");
             
             nuevoUsuario.append("procesoSeta", descripcion); // 💡 Fallback: Guardar en conversación/procesoSeta
             
             nuevoUsuario.append("id_requerimiento", this.requerimientoSeleccionado);
             // 🆕 Intentar enviar como observaciones también
             nuevoUsuario.append("observaciones", descripcion); 
             // También enviar JSON por si el backend evoluciona
             nuevoUsuario.append("respuestas_json", JSON.stringify(this.respuestasDinamicas));

        } else {
            // --- LÓGICA FACILISIMO (Original) ---
            nuevoUsuario.append("cc_id_asesor", id);
            nuevoUsuario.append("idEmpresa", idEmpresa);
            nuevoUsuario.append("procesoSeta", this.procesoSeta);
            nuevoUsuario.append("envioGiros", this.editedItem.envioGiros ? 'Si' : 'No');
            nuevoUsuario.append("pagoGiros", this.editedItem.pagoGiros ? 'Si' : 'No');
            nuevoUsuario.append("cedula", this.editedItem.cedula);
            nuevoUsuario.append("telefono", this.editedItem.telefono);
            nuevoUsuario.append("motivo", this.editedItem.motivo);
            nuevoUsuario.append("id_requerimiento", this.requerimientoSeleccionado);
            nuevoUsuario.append("idPunto", this.puntoSeleccionado || '');
        }

        // se crea el usuario
        axios.post(`${env.endpoint}callcenter/subir_casohuella`, nuevoUsuario)
        .then((response) => {
            let data = response.data;

            // 🧹 SANITIZACIÓN: Si el backend devuelve texto sucio (ej: "</div>{...}")
            if (typeof data === 'string') {
                try {
                    const jsonStart = data.indexOf('{');
                    const jsonEnd = data.lastIndexOf('}');
                    if (jsonStart !== -1 && jsonEnd !== -1) {
                        const jsonString = data.substring(jsonStart, jsonEnd + 1);
                        data = JSON.parse(jsonString);
                    }
                } catch (e) {
                    console.error("Error parseando respuesta sucia:", e);
                }
            }

            const estado = data && data.estado;

            if (estado) {
                swal({
                    title: 'CASO ESCALADO',
                    icon: 'success',
                    text: '¡EL CASO FUE ESCALADO CON EXITO!'
                })
                setTimeout(() => {
                  this.close();
                }, 1000);
            } else {
                swal({
                    title: 'Error',
                    icon: 'error',
                    text: 'El caso NO se escaló correctamente'
                });
            }
        })
        .catch((error) => {
            console.error('Error en la solicitud:', error);
        });
      },

      // Obtener puntos de venta para Facilísimo
      obtenerPuntos() {
        this.cargandoPuntos = true;
        const idUsuario = localStorage.getItem('id');
        axios
          .get(`${env.endpoint}user/puntostodos${idUsuario ? `?idUsuario=${idUsuario}` : ''}`)
          .then(({ data }) => {
            this.puntos = data;
          })
          .catch((err) => {
            console.error('Error al cargar puntos de venta:', err);
          })
          .finally(() => {
            this.cargandoPuntos = false;
          });
      },

      // 🆕 Obtener lista de requerimientos de Apostar
      obtenerRequerimientosApostar() {
        axios.get(`${env.endpoint}callcenter/requerimientostodos?todos=true`)
          .then((res) => {
            if (Array.isArray(res.data)) {
              // 🎯 Filtrar SOLO los IDs específicos de Desenrolamiento Apostar
              // 83: Jefes Hogar, 84: Renta Ciudadana, 98: Nominas IVA, 269: Colombia Mayor
              const whitelist = [83, 84, 98, 269, 282, 279];
              
              this.requerimientosApostar = res.data.filter(req => {
                return whitelist.includes(parseInt(req.cc_id_requerimientos));
              });
              
              // Validar selección por defecto
              const seleccionadoEsValido = this.requerimientosApostar.some(
                  r => r.cc_id_requerimientos == this.requerimientoSeleccionado
              );

              // Si la selección actual (ej: 35) ya no es válida, seleccionar el primero de la lista
              if (!seleccionadoEsValido && this.requerimientosApostar.length > 0) {
                  this.requerimientoSeleccionado = this.requerimientosApostar[0].cc_id_requerimientos;
              }
              
              // 🆕 Cargar preguntas del requerimiento inicial si existe
              if (this.requerimientoSeleccionado) {
                  this.obtenerPreguntas();
              }
            }
          })
          .catch((err) => {
            console.error('Error al cargar requerimientos:', err);
          });
      }
    },
};
</script>
